export default "__VITE_ASSET__8910c09f__"